export default __webpack_public_path__ + "static/media/icon_diamond.842b9218.svg";